// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3cRTw","text":"SelectPayment_text__2tEdv","title":"SelectPayment_title__1cnTD","btn":"SelectPayment_btn__35LXP"};